"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = require("react");
var react_query_1 = require("@tanstack/react-query");
var usePariluxAPI_1 = (0, tslib_1.__importDefault)(require("./usePariluxAPI"));
var ALL_ITEM_TYPES = 'ALL_ITEM_TYPES';
var useAllItemTypes = function (expanded) {
    if (expanded === void 0) { expanded = false; }
    var request = (0, usePariluxAPI_1.default)('FOSData').request;
    var getAllItemTypes = (0, react_1.useCallback)(function () { return (0, tslib_1.__awaiter)(void 0, void 0, void 0, function () {
        var data;
        return (0, tslib_1.__generator)(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, request({
                        url: "/pariluxdata/AllItemTypes".concat(expanded ? 'Ex' : ''),
                    })];
                case 1:
                    data = (_a.sent()).data;
                    return [2 /*return*/, data];
            }
        });
    }); }, [expanded, request]);
    return (0, react_query_1.useQuery)([ALL_ITEM_TYPES], getAllItemTypes);
};
exports.default = useAllItemTypes;
